import { render, staticRenderFns } from "./detailBanner.vue?vue&type=template&id=e401470a&"
import script from "./detailBanner.vue?vue&type=script&lang=js&"
export * from "./detailBanner.vue?vue&type=script&lang=js&"
import style0 from "./detailBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports